import { InteractiveMap } from '../../interfaces'

export const categoriesInteractive: InteractiveMap = (
  dispatch,
  interactiveState
) => ({
  partner_categories: {
    attributes: {
      categories: interactiveState?.globals?.header?.partnerCategories || [],
    },
  },
})
